<template>
    <v-container>
        <v-layout data-app wrap row>
            <v-flex xs12 class="align-self-center">
                <h1>Reports TEST = {{ this.testId }}</h1>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Reports1",
  data: () => ({
      testId: null
  }),
  created () {
    this.testId = this.$route.params.testId;
  },
  methods: {
  }
};
</script>

<style scoped>
.office-container {
    padding: 20px;
    border: 2px solid;
    margin: 10px 0;
    border-radius: 5px;
    background-color: white;
}
</style>
